import * as actions from './actionTypes';
import { Matrix } from 'api';

export const getPriceListDefault = () => ({
	type: actions.GET_PRICE_LIST_DEFAULT,
});

export const setPriceListDefault = (matrix?: Matrix) => ({
	type: actions.SET_PRICE_LIST_DEFAULT,
	payload: matrix,
});
